import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import VideoModalButton from "../molecules/VideoModalButton";
export default function FooterBanner(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-blue-500 text-white text-center block pt-9 pb-10 px-6 relative bg-blue-angle overflow-hidden footer-banner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative z-10 mx-auto max-w-lg lg:max-w-2xl"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-3xl lg:text-4xl font-heading mb-2.5"
    }, props.heading), /*#__PURE__*/ React.createElement("p", {
        className: "mb-5 md:mb-7 block"
    }, (props === null || props === void 0 ? void 0 : props.description) && /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-x-4 justify-center items-center mx-auto max-w-sm lg:max-w-full"
    }, props.callToActions.map(function(cta, key) {
        return (cta === null || cta === void 0 ? void 0 : cta.target.includes("wistia")) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(VideoModalButton, {
            target: cta.target,
            label: cta.label,
            buttonClasses: clsx("w-full lg:w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-primary bg-white text-gray-600 hover:bg-blue-100 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-white text-white hover:bg-blue-100 hover:border-blue-100 hover:text-gray-600 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY",
                "button-plain hover:text-blue-100 group w-full lg:w-auto flex items-center justify-center md:ml-1 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PLAIN"
            })
        })) : /*#__PURE__*/ React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            className: clsx("w-full lg:w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-primary bg-white text-gray-600 hover:bg-blue-100 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-white text-white hover:bg-blue-100 hover:border-blue-100 hover:text-gray-600 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY",
                "button-plain hover:text-blue-100 group w-full lg:w-auto flex items-center justify-center md:ml-1 focus-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PLAIN"
            })
        }, (cta === null || cta === void 0 ? void 0 : cta.display) !== "PLAIN" ? cta === null || cta === void 0 ? void 0 : cta.label : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
            width: "16",
            height: "16",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 18 18",
            className: "w-4 h-4 mr-2 relative -top-0.5"
        }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
            fill: "#fff",
            d: "M11.455 9.205H4.909V8h6.546zm-6.546-4.91h6.546v1.228H4.909zM2.455 0v11.864h9V16h-1.228v-2.91H0V18h13.91V2.455h1.226v4.09H18V0z"
        }))))), /*#__PURE__*/ React.createElement("span", null, cta.label), /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: "w-8 h-8 relative left-0 transition-all group-hover:left-1",
            viewBox: "0 0 36 40"
        }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "20",
            strokeWidth: "1.5",
            d: "M15.507 15.03v0l5.008 4.968v0l-5.008 4.93v0M20.51 20H7.81"
        })))))));
    }))));
}
